module.exports = __webpack_public_path__ + "static/media/headshot.239aad93.jpg";